import { IDmNguonBietToi, IDmNguonBietToiVm } from "../../../models/response/category/IDmNguonBietToi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objNguonBietToiDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as IDmNguonBietToiVm[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as IDmNguonBietToi | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IDmNguonBietToi,
    SAVE_SUCESS: {} as IDmNguonBietToi,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eNguonBietToiActionTypeIds = generateActionTypeIds(objNguonBietToiDefine, "NGUON_BIET_TOI")
export type INguonBietToiActionTypes = IGenericActionType<typeof objNguonBietToiDefine, "NGUON_BIET_TOI">
